import { HistoryPaymentPage } from './../history-payment/history-payment';
import { AlertController, PopoverController } from "ionic-angular";
import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { AuthService } from "../../services/auth.service";
import { DatePipe } from "@angular/common";
import { Users } from "../../models/users";

@Component({
  selector: "page-account",
  templateUrl: "account.html"
})
export class AccountPage {
  userData: Users;
  registerDate;
  paymentDate;
  endSubscriptionDate;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private authService: AuthService,
    private alertCtrl: AlertController,
    public datepipe: DatePipe,
    public popoverCtrl: PopoverController) {
    if (localStorage.getItem("UserDataLocal")) {
      this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));
      console.log("resLocal: " + this.userData.id);
      this.registerDate = new Date(this.userData.reg_date);
      this.paymentDate = new Date(this.userData.payment_date);
      this.endSubscriptionDate = new Date(this.userData.renewal_date);

    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad AccountPage");


    // this.registerDate = this.datepipe.transform(new Date(this.userData.reg_date), "dd-MM-yyyy");
    // this.paymentDate = this.datepipe.transform(new Date(this.userData.payment_date), "dd-MM-yyyy");
    // this.endSubscriptionDate = this.datepipe.transform(new Date(this.userData.renewal_date), "dd-MM-yyyy");

  }

  //Reset della password
  resetPassword() {
    console.log("email di rest: " + this.userData.email);
    this.authService.doResetPassword(this.userData.email).then(
      res => {
        const confirm = this.alertCtrl.create({
          title: "Reimposta Password",
          message: "Ti abiamo inviato un link via email per procedere con il reset della password",
          buttons: [
            {
              text: "Ok",
              handler: () => {
                console.log("ok");
              }
            }
          ]
        });
        confirm.present();
      },
      err => {
        console.error(err.message);
        const confirm = this.alertCtrl.create({
          title: "Errore",
          message: err.message,
          buttons: [
            {
              text: "Ok",
              handler: () => {
                console.log("error");
              }
            }
          ]
        });
        confirm.present();
      }
    );
  }

  ShowHistoryPayment(myEvent){


    const popover = this.popoverCtrl.create(HistoryPaymentPage, {}, { cssClass: "custom-popover"});

    let ev = {
      target : {
        getBoundingClientRect : () => {
          return {
            top: '20px'
          };
        }
      }
    };

    popover.present({
       ev
     // ev: myEvent
    });

    // this.navCtrl.push(HistoryPaymentPage, );

  }


   back(){
     this.navCtrl.pop();
   }

}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts